import type { CanvasPoint } from './canvasTypes'

function segmentDistance(
  point: CanvasPoint,
  a: CanvasPoint,
  b: CanvasPoint
): number {
  const dx = b.denormalized_x - a.denormalized_x,
    dy = b.denormalized_y - a.denormalized_y
  const lengthSquared = dx * dx + dy * dy
  const t = lengthSquared
    ? Math.max(
        0,
        Math.min(
          1,
          ((point.denormalized_x - a.denormalized_x) * dx +
            (point.denormalized_y - a.denormalized_y) * dy) /
            lengthSquared
        )
      )
    : 0
  return Math.hypot(
    point.denormalized_x - a.denormalized_x - t * dx,
    point.denormalized_y - a.denormalized_y - t * dy
  )
}

export function polylineDistance(
  points: CanvasPoint[],
  point: CanvasPoint,
  scale: { scale_x: number; scale_y: number } = { scale_x: 1, scale_y: 1 }
): number {
  const scaled = (p: CanvasPoint): CanvasPoint => ({
    denormalized_x: p.denormalized_x * scale.scale_x,
    denormalized_y: p.denormalized_y * scale.scale_y,
  })
  let distance = Infinity
  for (let i = 1; i < points.length; i++)
    distance = Math.min(
      distance,
      segmentDistance(scaled(point), scaled(points[i - 1]), scaled(points[i]))
    )
  return distance
}
